import "../Styles/PricingPlans.css";
import { CircleCheck, Globe, BriefcaseBusiness, Smartphone, Cpu } from "lucide-react";
import { useLang } from "../i18n/useLang";

function PricingPlans() {
  const { t } = useLang();
  const plans = t.home.pricing.plans;
  const iconByVariant = {
    starter: Globe,
    business: BriefcaseBusiness,
    custom: Cpu,
    mobile: Smartphone,
  };

  return (
    <div className="pp" aria-label="Pricing section">
      <div className="PPTop">
        <h2 className="pp-title">
          {t.home.pricing.titleLine1} <br /> {t.home.pricing.titleLine2}
        </h2>

        <p className="pp-subtitle">{t.home.pricing.subtitle}</p>
      </div>

      <div className="pp-grid">
        {plans.map((plan) => {
          const PlanIcon = iconByVariant[plan.variant] || Cpu;
          return (
            <article className="Plan" key={plan.id} data-variant={plan.variant}>
              <div className="PlanIconWrap" aria-hidden="true">
                <PlanIcon className="PlanIcon" />
              </div>

              <div className="PlanPrice">
                <p className="PlanSuffix">{t.home.pricing.priceSuffix}</p>
                <span>{plan.priceFrom}</span>
              </div>

              <div className="PlanTexts">
                <h3>{plan.title}</h3>
                <p>{plan.desc}</p>
              </div>

              <div className="PlanChecks" aria-label={`${plan.title} features`}>
                {plan.features.map((check) => (
                  <div className="textCont" key={check}>
                    <CircleCheck className="circlecheck" aria-hidden="true" focusable="false" />
                    <span>{check}</span>
                  </div>
                ))}
              </div>

              <a className="PlanGetStartedBtn" href="#contact">
                {t.home.pricing.cta}
              </a>
            </article>
          );
        })}
      </div>

      <p className="pp-note">{t.home.pricing.note}</p>
    </div>
  );
}

export default PricingPlans;
